import React from 'react';
import { Flex, Space, Typography } from 'antd';
import { Volume2, ZoomIn, ZoomOut } from 'lucide-react';
import { TimeMs } from '../../types';
import { colors, dimensions, typography } from '../../../theme';
import { TransportControls } from './transport-controls';
import { TimeDisplay } from './time-display';
import { SliderControl } from './slider-control';
import { ExpandButton } from './expand-button';

const { Text } = Typography;

type TimelineToolbarProps = {
  duration: TimeMs;
  isPlaying: boolean;
  playDisabled?: boolean;
  volume: number;
  zoom: number;
  expanded: boolean;
  onPlay: () => void;
  onPause: () => void;
  onRewind: () => void;
  onForward: () => void;
  onVolumeChange: (v: number) => void;
  onZoomChange: (v: number) => void;
  onToggleExpanded: () => void;
};

export const TimelineToolbar: React.FC<TimelineToolbarProps> = p => (
  <Flex
    align='center'
    justify='space-between'
    style={{
      height: 52,
      minHeight: 52,
      padding: `0 ${dimensions.spacing.xl}px`,
      backgroundColor: colors.toolbarBg,
      borderBottom: `1px solid ${colors.border}`,
      gap: dimensions.spacing['2xl']
    }}
  >
    <Space size={dimensions.spacing.xl} align='center'>
      <Text
        strong
        style={{
          fontFamily: typography.fontFamily.ui,
          fontSize: typography.fontSize.sm,
          color: colors.textSecondary,
          letterSpacing: typography.letterSpacing.wider,
          textTransform: 'uppercase'
        }}
      >
        Timeline Controls
      </Text>
      <TransportControls
        isPlaying={p.isPlaying}
        playDisabled={p.playDisabled}
        onPlay={p.onPlay}
        onPause={p.onPause}
        onRewind={p.onRewind}
        onForward={p.onForward}
      />
    </Space>

    <Space size={dimensions.spacing['3xl']} align='center'>
      <TimeDisplay total={p.duration} />
      {/*       <SliderControl
        value={p.volume}
        onChange={p.onVolumeChange}
        iconLeft={<Volume2 size={dimensions.size.iconSm} />}
        width={90}
        title='Volumen'
      />
      <SliderControl
        value={p.zoom}
        onChange={p.onZoomChange}
        iconLeft={<ZoomOut size={dimensions.size.iconSm} />}
        iconRight={<ZoomIn size={dimensions.size.iconSm} />}
        width={90}
        title='Zoom'
      /> */}
      <ExpandButton expanded={p.expanded} onClick={p.onToggleExpanded} />
    </Space>
  </Flex>
);
